/**
 * Text in die Ablage kopieren, mit Rückmeldung.
 *
 * `navigator.clipboard.writeText` gibt ein Versprechen zurück. Wer es nicht
 * auswertet, erfährt nie, ob es geklappt hat — und `navigator.clipboard?.` mit
 * Fragezeichen verschweigt zusätzlich, wenn die Schnittstelle ganz fehlt. Genau
 * das war der Fehler beim „Link"-Knopf: Er tat nichts und sagte nichts.
 *
 * Die Schnittstelle braucht einen sicheren Zusammenhang. Über HTTPS ist sie da,
 * über HTTP nicht — und in älteren Browsern auch nicht. Deshalb der Rückfall über
 * ein verstecktes Textfeld: `document.execCommand('copy')` ist veraltet, aber es
 * funktioniert überall und ist besser als ein Knopf, der nichts tut.
 */
export async function inDieAblage(text: string): Promise<boolean> {
  if (!text) return false;

  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch {
    /* Weiter mit dem Rückfall. */
  }

  try {
    const feld = document.createElement('textarea');

    feld.value = text;

    // Außerhalb des Bildes, aber im Baum: Ein Feld mit display:none lässt sich
    // nicht markieren, und ohne Markierung kopiert execCommand nichts.
    feld.style.position = 'fixed';
    feld.style.top = '-1000px';
    feld.style.opacity = '0';
    feld.setAttribute('readonly', '');

    document.body.appendChild(feld);
    feld.select();
    feld.setSelectionRange(0, text.length);

    const geklappt = document.execCommand('copy');

    document.body.removeChild(feld);

    return geklappt;
  } catch {
    return false;
  }
}
